import React, { useEffect, useState } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffectOnce } from "react-use";
import TostMessagesTop from "../../Component/Toast";
import GoLeft from "../../assets/GoLeft.png";
import sendEvents from "../../utils/sendEvents.js";
import Circle from "../../assets/Transportation/circle.svg";
import ColorCircle from "../../assets/Transportation/colorcircle.png";
import BreadCrumbHeader from "../../components/Header/BreadCrumbHeader";
import { TransportationStyle } from "./ChooseTransportationStyle.js";
import OrderProgressBar from "../../components/ProgressBar/OrderProgressBar.jsx";

function ChooseTransportation() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [boxone, setboxone] = useState(false);
  const [boxsecond, setboxsecond] = useState(false);
  const [shipRocketData, setShipRocketData] = useState([]);
  const [TransporterId, setTransporterId] = useState("");
  const [OrderData, setOrderData] = useState({});
  const [open, setOpen] = React.useState(true);

  const [TransportationCalculatedData, setTransportationCalculatedData] =
    useState({
      TransportationType: "",
      Transportationfee: 0,
      GSTFee: 0,
      TotalWithGST: 0,
      BXIShippingHandlingFee: 0,
      BXIShippingHandlingFeeGST: 0,
      TDS: 0,
      Total: 0,
    });

  async function GetOrderData() {
    await axios.get(`order/get_order_by_id/${id}`).then((res) => {
      setOrderData(res?.data);
    });
  }

  useEffectOnce(() => {
    GetOrderData();
  }, []);

  const NaviGateFunction = (InvoiceId) => {
    if (OrderData?.InvoiceData?.ProductData[0]?.ProductTypeName === "Media") {
      navigate(`/home/ordersummerydetails/${InvoiceId}`);
    } else {
      navigate(`/home/ordersummerydetails/${InvoiceId}`);
    }
  };

  function subtractPercentage(includedValue, percentage) {
    return includedValue / (1 + percentage / 100);
  }

  useEffect(() => {
    const FindObjectFromTransponsterId = Object.entries(shipRocketData).find(
      ([key, value]) => value.transporter_id === TransporterId
    );

    setTransportationCalculatedData({
      ...TransportationCalculatedData,
      TransportationType: FindObjectFromTransponsterId?.at(1)?.transporter_name,
      Transportationfee: subtractPercentage(
        FindObjectFromTransponsterId?.at(1)?.rates,
        18
      ),
      GSTFee:
        subtractPercentage(FindObjectFromTransponsterId?.at(1)?.rates, 18) *
        0.18,
      TotalWithGST: FindObjectFromTransponsterId?.at(1)?.rates,
      BXIShippingHandlingFee:
        subtractPercentage(FindObjectFromTransponsterId?.at(1)?.rates, 18) *
        0.05,

      BXIShippingHandlingFeeGST:
        subtractPercentage(FindObjectFromTransponsterId?.at(1)?.rates, 18) *
        0.05 *
        0.18,
      TDS:
        (subtractPercentage(FindObjectFromTransponsterId?.at(1)?.rates, 18) +
          subtractPercentage(FindObjectFromTransponsterId?.at(1)?.rates, 18) *
          0.05) *
        0.02,
      Total:
        subtractPercentage(FindObjectFromTransponsterId?.at(1)?.rates, 18) +
        subtractPercentage(FindObjectFromTransponsterId?.at(1)?.rates, 18) *
        0.05 +
        subtractPercentage(FindObjectFromTransponsterId?.at(1)?.rates, 18) *
        0.18 -
        (subtractPercentage(FindObjectFromTransponsterId?.at(1)?.rates, 18) +
          subtractPercentage(FindObjectFromTransponsterId?.at(1)?.rates, 18) *
          0.05) *
        0.05,
    });
  }, [TransporterId]);

  const AddChoosedTransportDataToInvoiceshiprocket = async (props) => {
    const FindObjectFromTransponsterId = Object.entries(shipRocketData).find(
      ([key, value]) => value.transporter_id === TransporterId
    );
    try {
      const { InvoiceData } = OrderData || {};

      const isSeller = props === "Seller";
      const transportationType = props;
      const transportationFee = isSeller
        ? Number(InvoiceData?.Transportationdata?.transportationfee)
        : TransportationCalculatedData?.Transportationfee;
      const GSTFee =
        (Number(InvoiceData?.Transportationdata?.transportationfee) *
          Number(InvoiceData?.Transportationdata?.gstFee)) /
        100;

      const buyerChoosedTransportation = {
        TransportationType: transportationType,

        Transportationfee: transportationFee,
        GSTFee: isSeller
          ? (OrderData?.Transportationdata?.transportationfee *
            OrderData?.Transportationdata?.gstFee) /
          100
          : TransportationCalculatedData?.GSTFee,
        TotalWithGST: isSeller
          ? transportationFee + GSTFee
          : TransportationCalculatedData?.Transportationfee +
          TransportationCalculatedData?.GSTFee,
        BXIShippingHandlingFee: isSeller
          ? 0
          : TransportationCalculatedData?.BXIShippingHandlingFee,
        BXIShippingHandlingFeeGST: isSeller
          ? 0
          : TransportationCalculatedData?.BXIShippingHandlingFeeGST,
        TDS: isSeller ? 0 : TransportationCalculatedData?.TDS,
        TransportersDetails: isSeller
          ? {}
          : FindObjectFromTransponsterId?.at(1),
      };

      const apiPayload = {
        BuyerChoosedTransportation: buyerChoosedTransportation,
      };

      const apiUrl = `order/update_seller_order/${id}`;

      const res = await axios.put(apiUrl, apiPayload);

      if (res?.data?.body?.BuyerChoosedTransportation !== null) {
        toast.success("Successfully Chosen Logistics", {
          position: "top-center",
          autoClose: 2000,
        });
        setTimeout(() => {
          NaviGateFunction(res?.data?.body?._id);
        }, 3000);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  useEffect(() => {
    if (!OrderData?.Transportationdata || OrderData?.Transportationdata?.transportationfee !== "") {
      setboxsecond(false);
    }
  }, []);
  const handleclick1 = () => {
    setboxone(true);
    setboxsecond(false);
  };

  const handleclick2 = () => {
    setboxone(false);
    setboxsecond(true);
  };



  const price = [
    {
      item: `GST ${OrderData?.Transportationdata?.gstFee} %`,
      value:
        (OrderData?.Transportationdata?.transportationfee *
          OrderData?.Transportationdata?.gstFee) /
        100,
    },
    {
      item: "Logistics fees",
      value: OrderData?.Transportationdata?.transportationfee,
    },
  ];


  return (
    <Paper
      elevation={0}
      sx={{
        boxShadow: "none",
        background: "transparent",
      }}
    >
      <BreadCrumbHeader MainText={"Choose Logistics"} showbreadcrumb={true} />
      <OrderProgressBar type={"Logistics"} Data={OrderData} />
      <Box
        sx={{
          bgcolor: "#fff",
          position: "relative",
          py: 5,
          borderRadius: "20px",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Box>
            <Button
              sx={{
                position: "absolute",
                left: "3%",
                top: "3%",
                cursor: "pointer",
                border: "none",
                outline: "none",
              }}
              onClick={() => {
                navigate(-1);
                sendEvents("Click");
              }}
            >
              <img
                src={GoLeft}
                style={{
                  width: "30px",
                }}
                alt="left-arrow"
              />
            </Button>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography
              sx={{
                fontFamily: "Poppins",
                color: "#6B7A99",
                fontSize: "18px",
                fontWeight: "600",
                marginTop: "0rem",
                mt: -3,
                textAlign: "center",
              }}
            >
              Select the logistics mode of your choice below.
            </Typography>
          </Box>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: "14px",
              color: "#B5BCCC",
              fontFamily: "Poppins",
              fontWeight: 400,
              mt: 1,
              textAlign: "center",
            }}
          >
            This quotation below is for the given address and you may decide
            your mode of Logistics.
          </Typography>
        </Box>
        <Paper
          sx={{
            width: "65%",
            mx: "auto",
            boxShadow: "none",
            background: "transparent",
            mt: 5,
          }}
          elevation={0}
        >
          <Box sx={{ mt: 4 }}>
            <Typography
              sx={packagingDetailsStyle}
            >
              Packaging Details
            </Typography>
            <Box
              sx={packagingdatastyle}
            >
              {OrderData?.PackagingData ? (
                <>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography sx={detailLabelStyle}>Packaging Cost</Typography>
                    <Typography sx={detailValueStyle}>
                      ₹ {OrderData?.PackagingData?.packagingcosts}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography sx={detailLabelStyle}>GST</Typography>
                    <Typography sx={detailValueStyle}>
                      {OrderData?.PackagingData?.packagingcostgstfee}%
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography sx={detailLabelStyle}>Number of Boxes</Typography>
                    <Typography sx={detailValueStyle}>
                      {OrderData?.PackagingData?.numberofboxes} boxes
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography sx={detailLabelStyle}>Total Weight</Typography>
                    <Typography sx={detailValueStyle}>
                      {OrderData?.PackagingData?.packagingweight} kg
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography sx={detailLabelStyle}>Pickup Date</Typography>
                    <Typography sx={detailValueStyle}>
                      {new Date(OrderData?.PackagingData?.pickupdate).toLocaleDateString('en-US', {
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric'
                      })}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                    <Typography sx={{
                      ...detailLabelStyle,
                      whiteSpace: "nowrap",  // Add this to prevent line breaks
                      fontSize: "11px",      // Slightly reduce font size to fit better
                    }}>
                      Box Dimensions (Height×Width×Length)
                    </Typography>
                    <Typography sx={detailValueStyle}>
                      {OrderData?.PackagingData?.boxheight} × {OrderData?.PackagingData?.boxwidth} × {OrderData?.PackagingData?.boxlength} cm
                    </Typography>
                  </Box>
                </>
              ) : (
                <Typography
                  sx={nopackagingdetails}
                >
                  No packaging details available.
                </Typography>
              )}
            </Box>
          </Box>

          <Box
            sx={{
              width: "95%",
              mx: "auto",
            }}
          >
            <Box
              sx={{
                height: "auto",
                minHeight: "100px",
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                flexDirection: "row",
              }}
            >
              <Box sx={adressbox}>
                <Typography sx={CommonTextStyle}>
                  Buyer Location for Delivery / Shipping Address of the Goods /
                  Services.
                </Typography>
                <Typography>
                  <div>
                    {OrderData &&
                      OrderData?.InvoiceData &&
                      OrderData?.InvoiceData.BuyerRequestedAddress ? (
                      <div>
                        <Typography
                          sx={{
                            ...deliverytext,
                            fontWeight: 400,
                            fontSize: "14px",
                          }}
                        >
                          Address:{" "}
                          <span style={{ color: "#445FD2" }}>
                            {
                              OrderData?.InvoiceData?.BuyerRequestedAddress
                                ?.Address
                            }
                          </span>
                        </Typography>
                        <Typography
                          sx={{
                            ...deliverytext,
                            fontWeight: 400,
                            fontSize: "14px",
                          }}
                        >
                          City:{" "}
                          <span style={{ color: "#445FD2" }}>
                            {
                              OrderData?.InvoiceData?.BuyerRequestedAddress
                                ?.City
                            }
                          </span>
                        </Typography>
                        <Typography
                          sx={{
                            ...deliverytext,
                            fontWeight: 400,
                            fontSize: "14px",
                          }}
                        >
                          State:{" "}
                          <span style={{ color: "#445FD2" }}>
                            {
                              OrderData?.InvoiceData?.BuyerRequestedAddress
                                ?.State
                            }
                          </span>
                        </Typography>
                        <Typography
                          sx={{
                            ...deliverytext,
                            fontWeight: 400,
                            fontSize: "14px",
                          }}
                        >
                          PinCode:{" "}
                          <span style={{ color: "#445FD2" }}>
                            {
                              OrderData?.InvoiceData?.BuyerRequestedAddress
                                ?.PinCode
                            }
                          </span>
                        </Typography>
                      </div>
                    ) : (
                      <div>
                        <Typography
                          sx={{
                            ...deliverytext,
                            fontWeight: 400,
                            fontSize: "13px",
                          }}
                        >
                          Address:{" "}
                          <span style={{ color: "#445FD2" }}>
                            {
                              OrderData?.InvoiceData?.BuyerDetails?.Address
                                ?.AddressLine
                            }
                          </span>
                        </Typography>
                      </div>
                    )}
                  </div>
                </Typography>
              </Box>
            </Box>
          </Box>

          <Box
            container
            sx={{
              height: "auto",
              display: "flex",
              marginTop: "3rem",
              justifyContent: "space-between",
              alignItems: "center",
              alignContent: "center",
              width: "95%",
              mx: "auto",
            }}
          >

            {OrderData?.Transportationdata?.transportationfee === "" ? null : (
              <Box
                onClick={handleclick1}
                sx={{
                  border: boxone ? "1px solid #6B7A99" : "1px solid #D9D9D9",
                  borderRadius: "10px",
                  width: "100%",
                  maxWidth: "460px",
                  height: "100%",
                  minHeight: "220px",
                  display: "flex",
                  cursor: "pointer",
                  flexDirection: "row",
                  "&:hover": {
                    border: "1px solid rgba(68, 95, 210, 1)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: "17%",
                  }}
                >
                  <Box
                    sx={{
                      marginTop: "16px",
                      width: "60px",
                      height: "60px",
                      mx: "auto",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={
                        OrderData?.InvoiceData?.SellerDetails?.SellerCompanyLogo
                      }
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        maxWidth: "60px",
                        maxHeight: "60px",
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    width: "83%",
                    p: 2,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography
                      sx={{
                        color: boxone ? " #6B7A99" : "rgba(107, 122, 153, 0.5)",
                        fontSize: "22px",
                        fontFamily: "Poppins",
                        fontWeight: 400,
                      }}
                    >
                      Seller Logistics
                    </Typography>
                    {boxone ? (
                      <img
                        src={ColorCircle}
                        alt="MyImage"
                        style={{ height: " fit-content" }}
                      />
                    ) : (
                      <img
                        src={Circle}
                        alt="MyImage"
                        style={{ height: " fit-content" }}
                      />
                    )}
                  </Box>

                  <Box sx={{ width: "85%" }}>
                    <Typography
                      sx={{
                        color: boxone ? " #445FD2 " : "rgba(71, 84, 103, 0.5);",
                        fontSize: "16px",
                        textAlign: "left",
                        fontFamily: "Poppins",
                        mt: 2,
                      }}
                    >
                      These are the delivery charges quoted by the Seller for
                      transportation of products.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}
            <Box
              onClick={handleclick2}
              sx={{
                border: boxone ? "1px solid #D9D9D9" : "1px solid #D9D9D9",
                borderRadius: "10px",
                width: "100%",
                maxWidth: "460px",
                height: "100%",
                minHeight: "220px",
                display: "flex",
                flexDirection: "row",
                cursor: "pointer",
                "&:hover": {
                  border: "1px solid rgba(68, 95, 210, 1)",
                },
              }}
            >
              <Box
                sx={{
                  width: "90%",
                  p: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      color: boxsecond
                        ? " #6B7A99"
                        : " rgba(107, 122, 153, 0.5)",
                      fontSize: "18px",
                      fontFamily: "Poppins",
                      fontWeight: 400,
                    }}
                  >
                    Buyer Logistics (Self transportation)
                  </Typography>
                  {boxsecond ? (
                    <img
                      src={ColorCircle}
                      alt="MyImage"
                      style={{ height: " fit-content" }}
                    />
                  ) : (
                    <img
                      src={Circle}
                      alt="MyImage"
                      style={{ height: " fit-content" }}
                    />
                  )}
                </Box>

                <Typography
                  sx={{
                    color: boxsecond ? " #445FD2 " : "rgba(71, 84, 103, 0.5);",
                    fontSize: "14px",
                    textAlign: "left",
                    fontFamily: "Poppins",
                    mt: 2,
                  }}
                >
                  You can choose self-pickup and delivery. You must co-ordinate
                  with the Seller to update the tracking status on the website.
                </Typography>
              </Box>
            </Box>
          </Box>

          {boxone ? (
            <Box
              sx={{
                width: "95%",
                mx: "auto",
                border: " 1px solid rgba(24, 2, 12, 0.05)",
                borderRadius: "10px",
                mt: 4,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Box sx={headbox2}>
                <Typography
                  sx={{
                    ...tableBottomDataStyle,
                    fontSize: "16px",
                    lineHeight: "24px",
                  }}
                >
                  Price Details ({OrderData?.InvoiceData?.ProductData?.length}{" "}
                  items)
                </Typography>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  height: "60%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                {price?.map((el, idx) => {
                  return (
                    <Box sx={mapbox} key={idx}>
                      <Typography sx={inrvalue}>
                        {price[price.length - idx - 1].item}
                      </Typography>
                      <Typography sx={inrvalue}>
                        {price[price.length - idx - 1].value}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>
              <Box sx={totaltextbox}>
                <Box sx={totaltextsec}>
                  <Typography sx={totaltext}>Total</Typography>
                  <Typography sx={totaltext}>
                    {" "}
                    {Number(
                      OrderData?.InvoiceData?.Transportationdata
                        ?.transportationfee
                    ) +
                      (OrderData?.InvoiceData?.Transportationdata?.gstFee *
                        Number(
                          OrderData?.InvoiceData?.Transportationdata
                            ?.transportationfee
                        )) /
                      100}{" "}
                    ₹
                  </Typography>
                </Box>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  py: 3,
                  width: "100%",
                  maxWidth: "500px",
                  mx: "auto",
                }}
              >
                {boxone ? (
                  <Button
                    sx={TransportationStyle.ConfirmButtonStyle}
                    onClick={() => {
                      AddChoosedTransportDataToInvoiceshiprocket("Seller");
                      sendEvents("Click on confirm");
                    }}
                  >
                    Confirm
                  </Button>) : (
                  <Button
                    disabled
                    sx={TransportationStyle.ConfirmButtonStyle}
                    onClick={() => {
                      AddChoosedTransportDataToInvoiceshiprocket("Seller");
                      sendEvents("Click on confirm");
                    }}
                  >
                    Confirm
                  </Button>
                )}

                <Button
                  onClick={() => {
                    navigate(-1);
                    sendEvents("Click on back");
                  }}
                  sx={TransportationStyle.CancelButtonStyle}
                >
                  Back
                </Button>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "space-between",
                py: 3,
                width: "100%",
                maxWidth: "500px",
                mx: "auto",
              }}
            >

              {boxsecond ? (
                <Button

                  sx={TransportationStyle.ConfirmButtonStyle}
                  onClick={() => {
                    AddChoosedTransportDataToInvoiceshiprocket(
                      "notransportation"
                    );
                    sendEvents("Click on confirm");
                  }}
                >
                  Confirm
                </Button>
              ) : (
                <Button
                  disabled
                  sx={TransportationStyle.ConfirmButtonStyle}
                  onClick={() => {
                    AddChoosedTransportDataToInvoiceshiprocket(
                      "notransportation"
                    );
                    sendEvents("Click on confirm");
                  }}
                >
                  Confirm
                </Button>
              )
              }
              <Button
                onClick={() => {
                  navigate(-1);
                  sendEvents("Click on back");
                }}
                sx={TransportationStyle.CancelButtonStyle}
              >
                Back
              </Button>
            </Box>
          )}
        </Paper>
      </Box>
      <TostMessagesTop PageLocation="Choose Transportation" />
    </Paper>
  );
}

export default ChooseTransportation;



const tableBottomDataStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "12px",
  color: "#6B7A99",
};

const CommonTextStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "21px",
  color: "#6B7A99",
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "100%",
};

const CommonTextStyleee = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "21px",
  color: "#6B7A99",
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "100%",
};
const CommonnnTextStyle = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#6B7A99",
  display: "-webkit-box",
  WebkitLineClamp: 1,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const adressbox = {
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  mt: 1,
  maxWidth: "500px",
};

const adressinput = {
  width: "500px",
  height: "42px",
  background: "#F9F9F9",
  borderRadius: "9px",
  px: 1,
  color: "#445fd2",
  fontSize: "12px",
};

const deliverytext = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#6B7A99",
};

const deliverytext2 = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
  color: "#6B7A99",
};

const mapbox = {
  width: "90%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
};

const inrvalue = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "20px",
  // textAlign: "center",
  color: "#6B7A99",
};

const totaltextbox = {
  width: "100%",
  height: "15%",
  borderTop: "1px solid rgba(149, 144, 168, 0.1)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
};

const totaltextsec = {
  width: "90%",
  height: "60px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
};

const totaltext = {
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "12px",
  lineHeight: "20px",
  // textAlign: "center",
  color: "#6B7A99",
};

const headbox2 = {
  width: "100%",
  height: "30px",
  display: "flex",
  width: "90%",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "flex-start",
  mt: 2,
};

const detailLabelStyle = {
  fontFamily: "Poppins",
  fontSize: "12px",
  fontWeight: 500,
  color: "#8896AB",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
};

const detailValueStyle = {
  fontFamily: "Poppins",
  fontSize: "16px",
  fontWeight: 600,
  color: "#445FD2",
  display: "flex",
  alignItems: "center",
  gap: 1,
};
const packagingDetailsStyle = {
  fontSize: "24px",
  color: "#445FD2",
  fontFamily: "Poppins",
  fontWeight: 600,
  textAlign: "center",
  mb: 3,
  textTransform: "uppercase",
  letterSpacing: "1px",
};
const packagingdatastyle = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 3,
  p: 3,
  border: "1px solid #E0E7FF",
  borderRadius: "16px",
  backgroundColor: "#FAFBFF",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
};
const nopackagingdetails = {
  fontFamily: "Poppins",
  fontSize: "14px",
  fontWeight: 400,
  color: "#6B7A99",
  gridColumn: "1 / -1",
  textAlign: "center",
  py: 4,
};

